import { createPortal } from 'react-dom';
import { type ReactNode } from 'react';
import { FrontRoyalModal } from './FrontRoyalModal';

// Overload 1: With title
/**
 * @deprecated Use Modal.tsx instead, if you need to create a modal from outside of React use createOutsideModal or createOutsideModalContent instead
 */
export function createModal(title: string, content: ReactNode): ReturnType<typeof createPortal>;

// Overload 2: Without title
/**
 * @deprecated Use Modal.tsx instead, if you need to create a modal from outside of React use createOutsideModal or createOutsideModalContent instead
 */
export function createModal(content: ReactNode): ReturnType<typeof createPortal>;

// Function Implementation
/**
 * @deprecated Use Modal.tsx instead, if you need to create a modal from outside of React use createOutsideModal or createOutsideModalContent instead
 */
export function createModal(titleOrContent: string | ReactNode, content?: ReactNode): ReturnType<typeof createPortal> {
    // Check if the first argument is a string (the title) or content
    const title = typeof titleOrContent === 'string' ? titleOrContent : undefined;
    const modalContent = content || titleOrContent;

    return createPortal(<FrontRoyalModal title={title}>{modalContent}</FrontRoyalModal>, document.body);
}
